import { FC } from 'react'
import Styles from './Actions.module.scss'

export const Actions: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div className={Styles.actions}>{children}</div>
)
